/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { easeOut, SlideIn } from '@atlaskit/motion';
/**
 * @internal
 */
export const NestingMotion = props => {
  const {
    children,
    enterFrom,
    exitTo,
    testId
  } = props;
  return jsx(SlideIn, {
    exitTo: exitTo,
    enterFrom: enterFrom,
    animationTimingFunction: _ => easeOut
  }, (innerProps, direction) => children({
    'data-enter-from': enterFrom,
    'data-exit-to': exitTo,
    'data-testid': testId && `${testId}-${direction}`,
    ...innerProps
  }));
};